import { ProductMediaAsset } from '@/features/ai-video-creator/stores/productMediaSlice';
import { getRequest } from './amplify/helpers';
import { z } from 'zod';
import { stringifyUrlParams } from '@tolstoy/utils/urlUtils';

export const RecommendedAvatarMediaQuerySchema = z.object({
  appUrl: z.string().min(1),
  appKey: z.string().min(1),
  productId: z.string().min(1),
});

export type RecommendedAvatarMediaQuery = z.infer<typeof RecommendedAvatarMediaQuerySchema>;

export type RecommendedMediaResponse = {
  mediaAssets: ProductMediaAsset[];
};

export const getRecommendedMedia = async (request: RecommendedAvatarMediaQuery): Promise<RecommendedMediaResponse> => {
  return getRequest({
    apiName: 'studio',
    path: `/templates/avatar-video/recommended-media?${stringifyUrlParams(request)}`,
  });
};
